export type JdWarehouseSlowLabel = '严重滞销' | '轻度滞销' | '无销售'
export type JdWarehouseJudgementKey = 'true-slow' | 'high-stock' | 'allocation' | 'review'

export interface JdWarehouseSlowMovingWarehouse {
  warehouse: string
  label: JdWarehouseSlowLabel
  spot: number
  innerTransit: number
  purchaseTransit: number
  expectedDays: number
  historyAverage: [number, number, number]
  historyTotal: [number, number, number]
  forecastAverage: [number, number, number]
  forecastTotal: [number, number, number]
  jdLogisticsProductCode: string
  firstEnteredSlowDate: string | null
  continuousSlowDays: number | null
}

export interface JdWarehouseSlowMovingProduct {
  code: string
  name: string
  sourceName: string
  image: string | null
  jdSkuCount: number
  stock: number
  labelStock: Record<JdWarehouseSlowLabel, number>
  labels: JdWarehouseSlowLabel[]
  warehouseCount: number
  warehouses: JdWarehouseSlowMovingWarehouse[]
  sales30: number
  gmv30: number
  lastSale: string | null
  daysSinceLastSale: number | null
  supportDays: number | null
  cost: number | null
  costMode: 'general-agent' | 'brand-special'
  costIssue: string | null
  occupiedCost: number | null
  judgement: string
  judgementKey: JdWarehouseJudgementKey
  judgementNote: string
}

export interface JdWarehouseSlowMovingData {
  schemaVersion: '1.0'
  generatedAt: string
  sourceSystem: string
  pageId: string
  granularity: string
  attribution: string
  productCodeFormat: '8-digit'
  snapshotDate: string
  salesStart: string
  salesEnd: string
  sourceDirectory: string
  sourceSetSha256: string
  snapshotPath: string
  snapshotHistory: {
    days: number
    minDate: string
    maxDate: string
    continuousMetricsReady: boolean
  }
  thresholds: {
    trueSlowMaxSales30: number
    trueSlowMinDaysSinceLastSale: number
    highStockMinSupportDays: number
    allocationMinSales30: number
  }
  summary: {
    productCount: number
    rowCount: number
    stock: number
    innerTransit: number
    purchaseTransit: number
    labelStock: Record<JdWarehouseSlowLabel, number>
    sales30: number
    gmv30: number
    occupiedCost: number
    mappedProductCount: number
    imageProductCount: number
    costProductCount: number
    soldProductCount: number
  }
  sources: Array<{
    file: string
    sha256: string
    rows: number
    label: JdWarehouseSlowLabel
    modifiedAt: string
  }>
  products: JdWarehouseSlowMovingProduct[]
}

export async function fetchJdWarehouseSlowMoving(signal?: AbortSignal): Promise<JdWarehouseSlowMovingData> {
  const response = await fetch('/data/jd-warehouse-slow-moving.json', { cache: 'no-store', signal })
  if (!response.ok) throw new Error(`京东仓滞销数据加载失败：${response.status}`)
  return response.json() as Promise<JdWarehouseSlowMovingData>
}
